import React from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';

interface AgeRangeData {
    range: string;
    count: number;
    percentage: number;
}

const ageRangeData: AgeRangeData[] = [
    { range: '18-25', count: 45, percentage: 21.1 },
    { range: '26-35', count: 78, percentage: 36.6 },
    { range: '36-45', count: 52, percentage: 24.4 },
    { range: '46-55', count: 31, percentage: 14.6 },
    { range: '56+', count: 7, percentage: 3.3 },
];

const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
                <p className="font-medium text-gray-900">{data.range} anos</p>
                <p className="text-sm text-gray-600">
                    {data.count} colaboradores ({data.percentage}%)
                </p>
            </div>
        );
    }
    return null;
};

export default function AgeRangeDistribution() {
    const totalCollaborators = ageRangeData.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="bg-white rounded-lg shadow p-4">
            {/* Header */}
            <div className="mb-4">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Faixa Etária
                </h3>
                <p className="text-xs text-gray-600">
                    Distribuição por idade dos {totalCollaborators} colaboradores
                </p>
            </div>

            {/* Chart */}
            <div className="h-48">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={ageRangeData} margin={{ top: 10, right: 10, left: 10, bottom: 20 }}>
                        <XAxis
                            dataKey="range"
                            tick={{ fontSize: 12 }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <YAxis hide />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar
                            dataKey="count"
                            fill="#3B82F6"
                            radius={[4, 4, 0, 0]}
                            stroke="#ffffff"
                            strokeWidth={1}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Stats Summary */}
            <div className="mt-4 grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">
                        {Math.round(ageRangeData.reduce((sum, item, index) => {
                            const midPoint = index === 0 ? 21.5 : index === 1 ? 30.5 : index === 2 ? 40.5 : index === 3 ? 50.5 : 60;
                            return sum + (midPoint * item.count);
                        }, 0) / totalCollaborators)}
                    </div>
                    <div className="text-xs text-gray-500">Idade Média</div>
                </div>
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">
                        {ageRangeData.find(item => item.count === Math.max(...ageRangeData.map(d => d.count)))?.range}
                    </div>
                    <div className="text-xs text-gray-500">Faixa Predominante</div>
                </div>
            </div>
        </div>
    );
} 